// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kCcO","colBig":"styles_colBig__2aqY6","colSmall":"styles_colSmall__3KJVm"};